// removed by extract-text-webpack-plugin
module.exports = {"upload-img-container":"upload-img-container","upload-img-wrap":"upload-img-wrap","upload-img-border":"upload-img-border","upload-img-clear-btn":"upload-img-clear-btn","upload-img-wrap-desc":"upload-img-wrap-desc","upload-img-desc":"upload-img-desc","wrap-input-upload":"wrap-input-upload","form-control-file":"form-control-file","btn-post-file":"btn-post-file","fa":"fa","upload-desc":"upload-desc"};


//////////////////
// WEBPACK FOOTER
// ./components/uploader/style.scss
// module id = ./components/uploader/style.scss
// module chunks = 0